import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { appRoutingModule } from './app-routing.module';
import { PasarelaPagoComponent } from './component/pasarela-pago/pasarela-pago.component';
import { NgxBsKaufmannModule } from "ngx-bs-kaufmann";
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TerminoWebpayComponent } from './component/termino-webpay/termino-webpay.component';
import { TerminoKhipuComponent } from './component/termino-khipu/termino-khipu.component';
import { HttpLoggingInterceptor } from './Logger/http-logging.interceptor';
import { ExitomComponent } from './component/exitom/exitom.component';
import { UrlIncorrectaComponent } from './component/url-incorrecta/url-incorrecta.component';
import { HttpErrorInterceptor } from 'src/utils/interceptors/http-error.interceptor';
import { ThousandSeparatorPipe } from './pipe/separedor-miles.pipe';

@NgModule({
  declarations: [
    AppComponent,
    PasarelaPagoComponent,
    TerminoWebpayComponent,
    TerminoKhipuComponent,
    ExitomComponent,
    UrlIncorrectaComponent,
    ThousandSeparatorPipe
  ],
  imports: [
    NgxBsKaufmannModule,
    BrowserModule,
    appRoutingModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpLoggingInterceptor,
    multi: true
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpErrorInterceptor,
    multi: true
  }
],
  bootstrap: [AppComponent]
})
export class AppModule { }
